import React from 'react';
import './styles.css';

const InputPill = ({
  value,
  onChange,
  placeholder,
  name,
  type = "text",
  autoComplete = "on",
  error,
  className = "",
  autoCapitalize = "none",
  autoCorrect = "off",
  spellCheck = false,
  inputMode,
  readOnly = false,
}) => {
  const classInput = `input-pill ${error ? "error" : ""} ${className}`;

  return (
    <>
      <input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        className={classInput}
        placeholder={placeholder}
        autoComplete={autoComplete}
        autoCapitalize={autoCapitalize}
        autoCorrect={autoCorrect}
        spellCheck={spellCheck}
        inputMode={inputMode || (type === "email" ? "email" : undefined)}
        readOnly={readOnly}
      />

      {error && error.length > 0 && (
        <div className="error-label">{error}</div>
      )}
    </>
  );
};

export default InputPill;
